import { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import cx from 'classnames'
import PropTypes from 'prop-types'

import classNames from './styles.module.scss'


Info.propTypes = {
  variant: PropTypes.oneOf(['default', 'error']),
  align: PropTypes.object,
  overlayClassName: PropTypes.string,
}

export default function Info({
  variant = 'default',
  align = {},
  overlayClassName = undefined,
  ...props
}) {
  const alignProp = useMemo(() => ({
    // For more information visit https://github.com/yiminghe/dom-align
    points: ['bc', 'tc'],
    overflow: { adjustX: true, adjustY: true, alwaysByViewport: true },
    ...align,
  }), [])

  return (
    <Tooltip {...props} align={alignProp} overlayClassName={cx(classNames.tooltip, overlayClassName)}>
      <i className={classNames.tapTarget}>
        <FontAwesomeIcon icon="info-circle" className={classNames[variant]} />
      </i>
    </Tooltip>
  )
}
